/// <amd-module name="VSS/Features/ReduxDirectory/Redux/DirectoryModule" />
import { IDirectoryAwareState } from "Contracts";
import { combineReducers } from "redux";
import { ISagaModule } from "redux-dynamic-modules-saga";
import { IDirectoryArtifact } from "VSS/Features/Directory/DirectoryContracts";
import { artifactReducer } from "VSS/Features/ReduxDirectory/Redux/Artifacts/ArtifactReducer";
import { directorySaga } from "VSS/Features/ReduxDirectory/Redux/DirectorySaga";
import { favoritesReducer } from "VSS/Features/ReduxDirectory/Redux/Favorites/FavoritesReducer";
import { directoryUIStateReducer } from "VSS/Features/ReduxDirectory/Redux/UIState/DirectoryUIStateReducer";

export const DirectoryModule: ISagaModule<IDirectoryAwareState<IDirectoryArtifact>> = {
    id: "directory",

    reducerMap: {
        // @ts-ignore TypeScript 3.5 update
        directoryState: combineReducers({
            directoryArtifactState: artifactReducer,
            favoriteState: favoritesReducer,
            uiState: directoryUIStateReducer
        } as any)
    },
    sagas: [directorySaga]
};
